import { HashStore, PulseEnvironment } from '@pulse/browser-shared';
import {
    AnalyticsPlugin,
    PulseStorage,
    StorageChangeKeyMatch,
    StorageChangeOrigin,
} from '@pulse/common';
import { concat, filter, map, of } from 'rxjs';
import { DeviceAttributesService } from '../services';

/**
 * Produces web attributes such as facebook pixel_id
 */
export class FacebookPixelAttributePlugin implements AnalyticsPlugin {
    constructor(
        private cookieStorage: PulseStorage,
        private hashStore: HashStore,
        private attributeService: DeviceAttributesService,
        private env: PulseEnvironment,
    ) {}

    init() {
        this.getPixelId();
    }

    getPixelId() {
        const fbp = this.cookieStorage.get('_fbp');
        const pixelIdChanges = this.cookieStorage
            .change('_fbp', StorageChangeKeyMatch.Full, StorageChangeOrigin.All)
            .pipe(map((change) => change.value));

        concat(of(fbp), pixelIdChanges)
            .pipe(
                filter(Boolean),
                filter((pixelId) => this.hashStore.changed('pixel_id_attr', pixelId)),
            )
            .subscribe((fb_pixel_id) => {
                this.env.win.dataLayer?.push({ pulse: 'attribute', fb_pixel_id });
                this.attributeService.send(true);
            });
    }
}
